export const dashboardConstants = {
  SET_DATA_LIST : "SET_DATA_LIST",
  SET_DATA : "SET_DATA",
  SET_CONT_LIST : "SET_CONT_LIST",
  SET_CONTRIBUYENTE : "SET_CONTRIBUYENTE",
  SET_GESTION_LIST : "SET_GESTION_LIST",
  SET_ACTUACION_LIST : "SET_ACTUACION_LIST",
  SET_ACTUACION : "SET_ACTUACION",
  SET_CONVENIO_LIST : "SET_CONVENIO_LIST",
  SET_CONVENIO : "SET_CONVENIO",
  CLEAR_CONVENIO : "CLEAR_CONVENIO",
  SET_ABOGADOS_LIST : "SET_ABOGADOS_LIST",
  SET_ABOGADO : "SET_ABOGADO",
  SET_INMUEBLES_LIST : "SET_INMUEBLES_LIST",
  CLEAR_INMUEBLES_LIST : "CLEAR_INMUEBLES_LIST",
  SET_INMUEBLE : "SET_INMUEBLE",
  SET_COND_LEG_LIST : "SET_COND_LEG_LIST",
  SET_COND_LEG : "SET_COND_LEG",
  SET_PLAN : "SET_PLAN",
  SET_PLAN_PAGO : "SET_PLAN_PAGO",
  SET_PLANES_LIST : "SET_PLANES_LIST",
  SET_PLANES_DATA : "SET_PLANES_DATA",
  SET_LEGAL_PLANES : "SET_LEGAL_PLANES",
  SET_DEUDA: "SET_DEUDA",
  SET_GRUPO_ETAPAS: "SET_GRUPO_ETAPAS",
  SET_TIPO_ETAPAS: "SET_TIPO_ETAPAS",
  SET_TIPO_RETIRO: "SET_TIPO_RETIRO",
  SET_CONV_ESTADO: "SET_CONV_ESTADO",
  CLEAR_DEUDA: "CLEAR_DEUDA",
  FETCH_STARTED : "FETCH_STARTED",
  FETCH_ERROR : "FETCH_ERROR",
  FETCH_SUCCESS : "FETCH_SUCCESS",
  SET_LOADING: "SET_LOADING",
  TIPO_DOCUMENTO: "TIPO_DOCUMENTO",
  CONV_CARACTER: "CONV_CARACTER",
  CONV_FORMAPAGOS: "CONV_FORMAPAGOS",
  SHOW_TABLE: "SHOW_TABLE",
  CLEAR: "CLEAR",
  SET_COMERCIOS_LIST : "SET_COMERCIOS_LIST",
  SET_IMPONIBLES : "SET_IMPONIBLES",
};
